<template>
  <v-dialog v-model="show" persistent max-width="380">
    <v-card>
      <v-card-title style="word-break: normal">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="description">
        {{ description }}
      </v-card-text>
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-btn color="secondary" text @click="close"> Cancelar </v-btn>
        <v-btn color="primary" text @click="ok"> Aceptar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmActionModal',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
  },
  data: () => ({
    show: false,
    payload: null,
  }),
  methods: {
    open(data) {
      this.payload = data;
      this.show = true;
    },
    ok() {
      this.show = false;
      this.$emit('ok', this.payload);
    },
    close() {
      this.show = false;
      this.$emit('close', this.payload);
    },
  },
};
</script>

<style></style>
